import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HideIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 5.54C13.5 5.54 14.88 5.94 16.12 6.58L18.84 3.86L20.16 5.16L17.74 7.58C19.42 8.84 20.78 10.48 21.76 11.96C19.84 14.86 16.48 18.38 12 18.38C10.52 18.38 9.16 18 7.94 17.38L5.24 20.06L3.94 18.76L6.32 16.38C4.6 15.12 3.24 13.46 2.24 11.96C4.16 9.06 7.52 5.54 12 5.54ZM12 7.24C8.58 7.24 6.34 9.62 4.34 11.96C5.32 13.1 6.36 14.26 7.56 15.14L9.48 13.22C9.28 12.84 9.18 12.42 9.18 11.96C9.18 10.4 10.44 9.14 12 9.14C12.46 9.14 12.88 9.24 13.26 9.44L14.86 7.84C14 7.46 13.06 7.24 12 7.24ZM12 16.68C15.42 16.68 17.66 14.3 19.66 11.96C18.7 10.84 17.68 9.7 16.5 8.82L9.2 16.1C10.04 16.46 10.98 16.68 12 16.68Z" />
    </SvgIcon>
  );
});
